import Testimonials2 from './Testimonials2'
export default Testimonials2
